<script setup>
import { ref, computed } from 'vue'
import { usePageBuilder } from '~/stores/page-builder'
import { useUrlBuilder } from '~/stores/url-builder'
import { storeToRefs } from 'pinia'

import { JFollowingMedia, JPertaciImage, JFilmStrip } from 'media-flow-ui'

import { $$t } from '~~/utils/i19m'

import Card from '~~/models/layout/components/content/Card'
import { CardModel } from '~/models/layout/components/content/CardStyle'
import { formatFontStyle } from '~/models/layout/style/font'
import { formatFollowingMediaStyle } from '~/models/layout/media/Media'
import { formatPadding, formatMargin } from '~/models/layout/style'

const pageBuilderStore = usePageBuilder()
const urlBuilderStore = useUrlBuilder()

const { getProjectDetails, deviceType } = storeToRefs(pageBuilderStore)
const { getProjectId, isCLH } = storeToRefs(urlBuilderStore)

const props = defineProps({
  data: {
    type: Object,
    required: false,
    default: false,
  },
})

const { data } = props
const isClickable = computed(
  () => data.props?.cards[deviceType.value]?.props?.clickable ?? true
)
const followingMediaData = ref([])

const skip = ref(0)
const take = ref(10)
const total = ref(20)

const style = computed(() => formatFollowingMediaStyle(data.style || {}))
const titleStyle = computed(() => {
  return {
    ...formatPadding(data.components.title?.style.padding),
    ...formatMargin(data.components.title?.style.margin),
    ...formatFontStyle(data.components.title?.style.fontProperties || {}),
  }
})

await useAsyncData(
  async () => {
    const params = {
      take: take.value,
      skip: skip.value,
    }

    let response

    try {
      response = await pageBuilderStore.actionGetMediaRelated(params)
    } catch (error) {
      console.error(error)
    }

    const parentGroupId =
      data.props?.cards[deviceType.value]?.props?.parentGroupId || null

    try {
      followingMediaData.value = response.data.map((rawCard) => {
        const cardData = new Card()
        const cardStyle = new CardModel()
        cardStyle.fromQuery(data.props.cards[deviceType.value])
        cardData.fromQuery(
          { ...rawCard, parentGroupId },
          null,
          true,
          isClickable
        )

        let isRedirect = false
        if (cardData.projectId === getProjectId.value) {
          isRedirect = false
        } else {
          const foundProjectDetails = getProjectDetails.value.get(
            cardData.projectId
          )

          if (foundProjectDetails) {
            isRedirect = true

            cardData.url = `https://${
              foundProjectDetails.assignedDomain || foundProjectDetails.domain
            }/${rawCard.url}`
          }
        }

        cardData.isRedirect = isRedirect

        return { props: cardData, style: cardStyle }
      })
    } catch (error) {
      console.error('meni', error)
    }

    if (response.total) {
      total.value = response.total
    }
  },
  {
    server: false,
  }
)

const updateGridDataWithWatchTime = async (data) => {
  const mediaIds = data.map((s) => s.props.id)

  const progressData = await pageBuilderStore.postGetWatchTimeByMediaIds(
    mediaIds
  )

  if (!progressData) return

  followingMediaData.value.map((media) => {
    const progress = progressData.find((p) => p.mediaId === media.props.id)

    if (progress) {
      const progressValue = Math.min(
        100,
        Math.ceil((progress.watchTime / media.props.length) * 100)
      )
      media.props.progressBarValue = progressValue
    }
    return media
  })
}

onMounted(async () => {
  await updateGridDataWithWatchTime(followingMediaData.value)
})

const loadMoreRelatedVideos = async () => {
  console.log('client calling load more folling media...')
}
</script>
<template>
  <div :id="data.id">
    <!-- <pre>
    {{ isClickable }}
    {{ followingMediaData.map(s => s.props.id) }}
  </pre> -->
    <input
      type="hidden"
      class="vp-component-following-media"
      name="FollowingMedia"
      :value="JSON.stringify(followingMediaData)"
    />

    <JFollowingMedia
      v-if="followingMediaData.length > 0 && !isCLH"
      :media="followingMediaData"
      :callback="loadMoreRelatedVideos"
      :breakpoint="deviceType"
      :title="data.components.title.props.text"
      :style="style"
      :title-style="titleStyle"
      :new-item-text="$$t('component_card_new_text')"
    >
      <template #card-image="{ image, style, filmstrip, isFilmstrip, alt }">
        <JPertaciImage
          :imageSrc="image"
          :alt="alt"
          no-lazy-image
          class="w-full"
          :style="style"
        />

        <JFilmStrip
          v-if="isFilmstrip"
          :src="filmstrip"
          :style="style"
          :switch-time="0.5"
        />
      </template>
    </JFollowingMedia>
  </div>
</template>

<style lang="scss">
.j-card {
  &.thumbnail_left,
  &.thumbnail_right {
    img {
      width: 200px !important;
      max-width: 200px !important;
    }

    &.tablet {
      img {
        width: 120px !important;
        max-width: 120px !important;
      }
    }
  }
}
</style>
